import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import moment from 'moment'

import { BOOKING_PAYMENT_SET_PAYMENT_INTENT,
         BOOKING_PAYMENT_UPDATE_BOOKDETAILS,
         BOOKING_PAYMENT_SET_EXPRESS_CHECKOUT,
         BOOKING_PAYMENT_START,
         BOOKING_PAYMENT_SUCCESS,
         BOOKING_PAYMENT_ERROR } from '../../../constants';

// Redux
import { connect } from 'react-redux';

// Redux Form
import { Field, reduxForm, /* submit, */ SubmissionError/* , formValueSelector, reset */ } from 'redux-form';

import {
  Row,
  //FormGroup,
  Col,
  FormControl
} from 'react-bootstrap';

// Stripe
import {
  PaymentElement,
  ExpressCheckoutElement,
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement
} from '@stripe/react-stripe-js';
import { toastr } from 'react-redux-toastr';

// Config
import { url, isLive } from '../../../config';

import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Payment.css';
import bt from '../../../components/commonStyle.css';

// Helpers
import validate from './validate';
import fetch from '../../../core/fetch';
import trackBooking from '../../../helpers/trackBooking';
//import { datecmp } from '../../../helpers/pleXpad';

// Component
import Loader from '../../Loader';
import { openLoginModal } from '../../../actions/modalActions';

// Locale
import messages from '../../../locale/messages';

// Action
import { makePayment } from '../../../actions/booking/makePayment';

//Images 
import imageOne from '../../../../public/SiteIcons/payment-icons.png';
import imageTwo from '../../../../public/SiteIcons/stripe-connect.png';

//import { isRTL } from '../../../helpers/formatLocale';

const stripeOptions = {
  style: {
    base: {
      color: '#484848',
      fontWeight: 400,
      fontFamily: 'inherit',
      fontSize: '14px',
      fontSmoothing: 'antialiased',
      ':focus': {
        color: '#484848',
      },

      '::placeholder': {
        color: '#aaa',
      },

      ':focus::placeholder': {
        color: '#aaa',
      },
    },
    invalid: {
      color: '#484848',
      ':focus': {
        color: '#484848',
      },
      '::placeholder': {
        color: '#aaa',
      },
    },
  }
};

const submitPaymentForm = async (values, dispatch, props) => {
  const { stripe, elements, isAuthenticated, isExpressCheckout, monthlyPass, monthlyPassAuthDeposit, monthlyPassSubscriptionStage, monthlyPassIsSubscription } = props;
  let { paymentIntentId, clientSecret } = props;
  let { setupIntentId, setupIntentClientSecret } = props;
  let { bookDetails } = props;

  let guestEmail = Boolean(values.email) ? values.email : values.guestEmail;

  if( !monthlyPass ) {
    let query = `query checkReservation ($checkIn: String,$checkOut: String,$listId: Int,$isHotDesking: Boolean,$guests: Int ){
      checkReservation(checkIn: $checkIn, checkOut:$checkOut, listId:$listId, isHotDesking:$isHotDesking, guests:$guests ){
        status
      }
    }`;

    values.checkIn = moment(values.checkIn).format('YYYY-MM-DD');
    values.checkOut = moment(values.checkOut).format('YYYY-MM-DD');

    const params = {
      listId: values.listId,
      checkIn: values.checkIn,
      checkOut: values.checkOut,
      isHotDesking: values.isHotDesking,
      guests: values.guests
    };

    const resp = await fetch('/graphql', {
      method: 'post',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        query,
        variables: params,
      }),
      credentials: 'include',
    });

    const { data } = await resp.json();

    if( !data || !data.checkReservation || data.checkReservation.status !== '200' ) {
      toastr.error('Sorry', 'Those dates have become unavailable.');
      return false;
    }
  }

  if( !isAuthenticated && typeof values.email !== undefined && values.email ) {
    let query = `query checkEmail ($email: String!) {
      checkEmail(email: $email) {
        status
        error
        userType
      }
    }`;
    const checkEmailResp = await fetch('/graphql', {
      method: 'post',
      headers: {
        Accept: 'application/json',
                'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        query,
        variables: {email: values.email},
      })
    });

    const { data } = await checkEmailResp.json();
    const checkEmail = data ? data.checkEmail : false;

    if( !checkEmail || !checkEmail.status || checkEmail.status == '500' ) {
      toastr.error('Error', 'There was a problem. Please try again. If the problem persists, please contact us.');
      return false;
    }
    else if( checkEmail.status !== '200' ) {
      dispatch({type: BOOKING_PAYMENT_ERROR,
                payload: {
                  status: checkEmail.status,
                  existingUserType: checkEmail.userType,
                  error: checkEmail.error,
                  errorType: 'createUser',
                  paymentLoading: false
                }});
      return false;
    }
  }
  
  if( monthlyPass && monthlyPassSubscriptionStage ) {
    await dispatch({
      type: BOOKING_PAYMENT_START,
      payload: {
        paymentLoading: true
      }
    });

    // Trigger form validation and wallet collection
    const { error: submitError } = await elements.submit();
    if( submitError ) {
      await dispatch({
        type: BOOKING_PAYMENT_ERROR,
        payload: { paymentLoading: false }
      });

      toastr.error('Error', submitError);
      return false;
    }

    let reservationId = bookDetails.reservationId;
    let convertedAmount = bookDetails.convertedAmount;
    
    bookDetails = Object.assign({}, bookDetails, {
      monthlyPass: true,
      checkoutReturn: true
    });

    //#region createBACSPaymentMethod
    /*
    let BACSPaymentMethodId;
    const createBACSPaymentMethod = await stripe.createPaymentMethod({
      type: 'bacs_debit', //Probably possible only server-side
      bacs_debit: {
        account_number: values.bankAccountNumber.toString().trim(),
        sort_code: values.bankAccountSortCode.toString().replace(/[\s\-]/g, '')
      }
    });

    if (createBACSPaymentMethod && createBACSPaymentMethod.paymentMethod) {
      BACSPaymentMethodId = createBACSPaymentMethod.paymentMethod.id
    }
    else if( createBACSPaymentMethod && createBACSPaymentMethod.error && createBACSPaymentMethod.error.message ) {
      toastr.error("Error", createBACSPaymentMethod.error.message);
      return false;
    }
    return true;
    */
    //#endregion
    //#region subscriptionSchedule
    //let subscriptionSchedule = datecmp(values.checkIn, Date(), true) !== 0;

    if( !monthlyPassIsSubscription ) {
      const stripeSetup = await stripe.confirmSetup({
        elements,
        clientSecret: setupIntentClientSecret,
        confirmParams: {
          return_url: `${url}/book/${values.listId}?bookDetails=${encodeURIComponent(JSON.stringify(bookDetails))}`,
          payment_method_data: {
            billing_details: {
              email: guestEmail
            }
          }
        },
        redirect: 'if_required'
      });

      if( stripeSetup.error ) {
        throw new Error('An error occurred setting up the Direct Debit (ER_DD_2)');
      }
      else {
        let status, errorMessage;
        const resp = await fetch('/stripe-subscription', {
          method: 'post',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ reservationId, convertedAmount: Math.round(convertedAmount*100), bookDetails, paymentMethodId: stripeSetup.setupIntent.payment_method }),
          credentials: 'include'
        });
        ({ status, errorMessage } = await resp.json());
        
        if( status !== 200 ) {
          await dispatch({
            type: BOOKING_PAYMENT_ERROR,
            payload: { paymentLoading: false }
          });

          toastr.error('Error', 'An error occurred creating your subscription. ' + errorMessage);
          return false;
        }
      }
    }
    else {
      let status, errorMessage;
      const resp = await fetch('/stripe-subscription', {
        method: 'post',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ reservationId, convertedAmount: Math.round(convertedAmount*100), bookDetails }),
        credentials: 'include'
      });
      ({ status, errorMessage, paymentIntentId, paymentIntentSecret: clientSecret } = await resp.json());
      
      if( status !== 200 ) {
        await dispatch({
          type: BOOKING_PAYMENT_ERROR,
          payload: { paymentLoading: false }
        });

        toastr.error('Error', 'An error occurred creating your subscription. ' + errorMessage);
        return false;
      }

      // Use the clientSecret and Elements instance to confirm the setup
      const { error } = await stripe.confirmPayment({
        elements,
        clientSecret,
        confirmParams: {
          return_url: `${url}/book/${values.listId}?bookDetails=${encodeURIComponent(JSON.stringify(bookDetails))}`,
          payment_method_data: {
            billing_details: {
              email: guestEmail
            }
          }
        },
        redirect: 'if_required'
      });

      if( error ) {
        await dispatch({
          type: BOOKING_PAYMENT_ERROR,
          payload: { paymentLoading: false }
        });

        toastr.error('Error', 'An error occurred setting up the Direct Debit (ER_DD_3)');
        return false;
      }
    }

    await dispatch({
      type: BOOKING_PAYMENT_SUCCESS,
      payload: { paymentLoading: true }
    });

    trackBooking({
      currency: values.currency,
      value: convertedAmount,
      reservationId,
      listingId: values.listId,
      listingTitle: values.listTitle
    });

    window.location = '/users/trips/itinerary/' + reservationId;
    return true;
  }
  
  let paymentMethodId = '';

  if( !isExpressCheckout && (!monthlyPass || monthlyPassAuthDeposit) ) {
    if( !values.zipcode || values.zipcode.trim() == '' ) {
      throw new SubmissionError({ zipcode: 'Your Postcode is incomplete.' });
    }
    
    const cardNumberElement = elements.getElement(CardNumberElement);

    const createPaymentMethod = await stripe.createPaymentMethod({
      type: 'card',
      card: cardNumberElement,
      billing_details: {
        address: {
          postal_code: values.zipcode
        }
      }
    })

    if (createPaymentMethod && createPaymentMethod.paymentMethod) {
      paymentMethodId = createPaymentMethod.paymentMethod.id
      
      await dispatch({
        type: BOOKING_PAYMENT_UPDATE_BOOKDETAILS,
        payload: {
          paymentMethodId
        }
      });
    }
    else {
      toastr.error("Error", createPaymentMethod && createPaymentMethod.error && createPaymentMethod.error.message ? createPaymentMethod.error.message : 'An error occurred creating the payment method');
      return false;
    }
  }

  const { status, paymentIntentId: currentPaymentIntentId, paymentIntentSecret, reservationId, convertedAmount } = await dispatch(makePayment({
    ...values,
    guestEmail,
    paymentMethodId,
    isExpressCheckout,
    monthlyPass,
    monthlyPassAuthDeposit,
    monthlyPassSubscriptionStage,
    paymentIntentId
  }));

  if( currentPaymentIntentId ) {
    paymentIntentId = currentPaymentIntentId;
  }

  if( paymentIntentSecret ) {
    clientSecret = paymentIntentSecret;
  }

  if( status == 401 ) {
    const cardAction = await stripe.handleCardAction(paymentIntentSecret);

    // If handled via a overlay... (otherwise PaymentForm.componentDidMount handles the confirmation)
    if (cardAction && cardAction.paymentIntent && cardAction.paymentIntent.id) {
      trackBooking({
        currency: values.currency,
        value: convertedAmount,
        reservationId,
        listingId: values.listId,
        listingTitle: values.listTitle
      });
  
      await dispatch({
        type: BOOKING_PAYMENT_SUCCESS,
        payload: { paymentLoading: true }
      });
      window.location = '/users/trips/itinerary/' + reservationId;
    }
    else {
      await dispatch({
        type: BOOKING_PAYMENT_ERROR,
        payload: { paymentLoading: false }
      });
      toastr.error('Error', 'Payment Authorisation Failed. Please Try again.');
    }
  }

  if( status != 200 ) {
    return false;
  }

  if( monthlyPass && monthlyPassAuthDeposit ) {
    await dispatch({
      type: BOOKING_PAYMENT_UPDATE_BOOKDETAILS,
      payload: {
        checkoutReturn: false,
        monthlyPassAuthDeposit: false,
        monthlyPassSubscriptionStage: true
      }
    });

    /* bookDetails = Object.assign({}, bookDetails, {
      monthlyPass: true,
      checkoutReturn: true
    });

    let subscriptionStatus, subscriptionErrorMessage, setupIntentId, setupIntentSecret;
    const resp = await fetch('/stripe-subscription', {
      method: 'post',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ reservationId, convertedAmount: Math.round(convertedAmount*100), bookDetails }),
      credentials: 'include'
    });
    ({ status: subscriptionStatus, errorMessage: subscriptionErrorMessage, setupIntentId, setupIntentSecret } = await resp.json());
    
    if( subscriptionStatus !== 200 ) {
      await dispatch({
        type: BOOKING_PAYMENT_ERROR,
        payload: { paymentLoading: false }
      });

      toastr.error('Error', 'An error occurred creating your subscription. ' + subscriptionErrorMessage);
      return false;
    }

    if( setupIntentSecret ) {
      try {
        const confirmSetup = await stripe.confirmSetup({
          clientSecret: setupIntentSecret,
          redirect: 'if_required'
        });

        trackBooking({
          currency: values.currency,
          value: convertedAmount,
          reservationId,
          listingId: values.listId,
          listingTitle: values.listTitle
        });
    
        await dispatch({
          type: BOOKING_PAYMENT_SUCCESS,
          payload: { paymentLoading: true }
        });
        window.location = '/users/trips/itinerary/' + reservationId;
      }
      catch( error ) {
        toastr.error("Error", error.message);
        return false;
      }
    } */

    return true; //Make sure the implicit promise resolves so `submitting` prop is set back to false
  }
}

class PaymentForm extends Component {
  static propTypes = {
    houseRules: PropTypes.arrayOf(PropTypes.shape({
      listsettings: PropTypes.shape({
        itemName: PropTypes.string.isRequired
      })
    })),
    hostDisplayName: PropTypes.string.isRequired,
    allowedPersonCapacity: PropTypes.number.isRequired,
    initialValues: PropTypes.shape({
      listId: PropTypes.number.isRequired,
      listTitle: PropTypes.string.isRequired,
      hostId: PropTypes.string.isRequired,
      guestId: PropTypes.string.isRequired,
      checkIn: PropTypes.object.isRequired,
      checkOut: PropTypes.object,
      guests: PropTypes.number.isRequired,
      basePrice: PropTypes.number.isRequired,
      cleaningPrice: PropTypes.number.isRequired,
      currency: PropTypes.string.isRequired,
      weeklyDiscount: PropTypes.number,
      monthlyDiscount: PropTypes.number,
      paymentType: PropTypes.number
    }).isRequired,
    /* paymentCurrencyList: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      symbol: PropTypes.string.isRequired,
      isEnable: PropTypes.bool.isRequired,
      isPayment: PropTypes.bool.isRequired
    })), */
    paymentLoading: PropTypes.bool,
    formatMessage: PropTypes.any,
  };

  static defaultProps = {
    paymentLoading: false,
    isExpressCheckout: false
  };

  constructor(props) {
    super(props);
    this.state = {
      load: true,
      expressCheckoutCount: -1,
      stripeTestDetailsPrefilled: false
    }
    this.onExpressCheckoutReady = this.onExpressCheckoutReady.bind(this);
    this.onExpressCheckoutClick = this.onExpressCheckoutClick.bind(this);
    this.onExpressCheckoutConfirm = this.onExpressCheckoutConfirm.bind(this);
    this.initialiseStripe = this.initialiseStripe.bind(this);
    //this.prefillStripeTestDetails = this.prefillStripeTestDetails.bind(this);
  }

  async initialiseStripe() {
    const { initialValues, dispatch, bookDetails, monthlyPass, monthlyPassIsSubscription } = this.props;
    
    //subscriptionSchedule
    //const subscriptionSchedule = monthlyPass && datecmp(initialValues.checkIn, Date(), true) !== 0;
    if( monthlyPass && !monthlyPassIsSubscription ) {
      let payload = {};
      const resp = await fetch('/stripe-create-setup-intent', {
        method: 'post',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload),
        credentials: 'include'
      });
      const { status, stripeStatus, setupIntentId, clientSecret, errorMessage } = await resp.json();

      if( status == 200 ) {
        await dispatch({
          type: BOOKING_PAYMENT_UPDATE_BOOKDETAILS,
          payload: {
            setupIntentId,
            setupIntentClientSecret: clientSecret,
          }
        });
      }
      else {
        toastr.error('Error', errorMessage ? errorMessage : 'Sorry, something went wrong with the checkout. If the problem persists, please get in touch.');
      }

      return true;
    }
    
    // Create the PaymentIntent and obtain clientSecret (for Express Checkout and monthly pass BACS)
    let payload = {
      amount: Math.round(initialValues.total * 100),
      currency: initialValues.paymentCurrency.toLowerCase()
    };
    const resp = await fetch('/stripe-create-intent', {
      method: 'post',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload),
      credentials: 'include'
    });
    const { status, stripeStatus, paymentIntentId, clientSecret, errorMessage } = await resp.json();

    if( status == 200 ) {
      await dispatch({
        type: BOOKING_PAYMENT_SET_PAYMENT_INTENT,
        payload: {
          paymentIntentId,
          clientSecret
        }
      });

      // Existing payment intent is currently used only for Express Checkout and Subscription, but dispatch to bookDetails just in case this changes in future
      await dispatch({
        type: BOOKING_PAYMENT_UPDATE_BOOKDETAILS,
        payload: {
          paymentIntentId,
          paymentIntentClientSecret: clientSecret,
          //subscriptionSchedule
        }
      });
    }
    else {
      toastr.error('Error', errorMessage ? errorMessage : 'Sorry, something went wrong with the checkout. If the problem persists, please get in touch.');
    }
  }

  confirmBooking = async (bookDetails, dispatch) => {
    let { listId, listTitle, reservationId, paymentIntentId, currency, convertedAmount } = bookDetails;
  
    const confirmPaymentIntent = await fetch('/stripe-reservation', {
      method: 'post',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ action: 'confirm', reservationId, paymentIntentId }),
      credentials: 'include'
    });
    const { status: confirmStatus, errorMessage: confirmErrorMessage } = await confirmPaymentIntent.json();
  
    if( confirmStatus === 200 ) {
      trackBooking({
        currency,
        value: convertedAmount,
        reservationId,
        listingId: listId,
        listingTitle: listTitle
      });
  
      await dispatch({
        type: BOOKING_PAYMENT_SUCCESS,
        payload: { paymentLoading: true }
      });
  
      window.location = '/users/trips/itinerary/' + reservationId;
    }
    else {
      await dispatch({
        type: BOOKING_PAYMENT_ERROR,
        payload: { paymentLoading: false }
      });
      toastr.error('Error', confirmErrorMessage ? confirmErrorMessage : 'There was a problem completing your booking. Please try again.');
    }
  }

  /* async prefillStripeTestDetails() {
    let test = true;

    if( !isLive && !this.state.stripeTestDetailsPrefilled && this.props.stripe ) {
      const { elements } = this.props;

      const cardNumberElement = elements.getElement(CardNumberElement);
      const cardExpiryElement = elements.getElement(CardExpiryElement);
      const cardCvcElement = elements.getElement(CardCvcElement);

      if( cardNumberElement && cardExpiryElement && cardCvcElement ) {
        cardNumberElement.update({value: '4242424242424242'});
        cardExpiryElement.update({value: '12/34'});
        cardCvcElement.update({value: '123'});
        this.state.stripeTestDetailsPrefilled = true;
      }
    }
  } */

  async componentDidMount() {
    const { dispatch, bookDetails, monthlyPassAuthDeposit } = this.props;

    if( bookDetails.expressCheckoutReturn ) {
      if( !bookDetails.paymentIntentId ) {
        toastr.error('Error', errorMessage ? errorMessage : 'Sorry, something went wrong with the express checkout. If the problem persists, please get in touch.');
        return false;
      }
      //TODO: load back in the form data
    }
    else if( bookDetails.checkoutReturn ) {
      await this.confirmBooking(bookDetails, dispatch);
      return true;
    }

    if( !monthlyPassAuthDeposit ) {
      await this.initialiseStripe();
    }
    //await this.prefillStripeTestDetails();
  }

  async componentDidUpdate(prevProps) {
    const { locale } = this.props.intl;
    const { locale: prevLocale } = prevProps.intl;

    const { monthlyPass, monthlyPassSubscriptionStage, bookDetails } = this.props;

    if (locale !== prevLocale) {
      this.setState({ load: false });
      clearTimeout(this.loadSync);
      this.loadSync = null;
      this.loadSync = setTimeout(() => this.setState({ load: true }), 1);
    }

    if( monthlyPass && !prevProps.monthlyPassSubscriptionStage && monthlyPassSubscriptionStage ) {
      await this.initialiseStripe();
      this.state.stripeTestDetailsPrefilled = false;
    }
    //await this.prefillStripeTestDetails();
  }

  //#region Unused Methods
  /* renderFormControlSelect = ({ input, label, meta: { touched, error }, children, className, disabled, }) => {
    const { formatMessage } = this.props.intl;
    return (
      <div>
        <FormControl disabled={disabled} componentClass="select" {...input} className={className} >
          {children}
        </FormControl>
        {touched && error && <span className={s.errorMessage}>{formatMessage(error)}</span>}
      </div>
    )
  } */

  /* renderFormControlTextArea = ({ input, label, meta: { touched, error }, children, className }) => {
    const { formatMessage } = this.props.intl;
    return (
      <FormGroup>
        <FormControl
          {...input}
          className={className}
          componentClass="textarea"
          placeholder={label}
        >
          {children}
        </FormControl>
        {touched && error && <span className={s.errorMessage}>{formatMessage(error)}</span>}
      </FormGroup>
    );
  } */

  /* renderGuests(personCapacity) {
    const { formatMessage } = this.props.intl;

    let rows = [];
    for (let i = 1; i <= personCapacity; i++) {
      rows.push(<option key={i} value={i}>{i} {i > 1 ? formatMessage(messages.guests) : formatMessage(messages.guest)}</option>);
    }
    return rows;
  } */

  /* renderpaymentCurrencies() {
    const { paymentCurrencyList } = this.props;
    let rows = [];

    if (paymentCurrencyList != null && paymentCurrencyList.length > 0) {
      paymentCurrencyList.map((item, index) => {
        if (item.isEnable && item.isPayment) {
          rows.push(<option key={index} value={item.symbol}>{item.symbol}</option>);
        }
      })
    }
    return rows;
  } */

  /* handleClick() {
    const { dispatch } = this.props;
    dispatch(reset('BookingForm'));
  } */

  /* handlePayment(e) {
    let paymentType = e.target.value;

    if (paymentType == 2) {
      this.setState({ paymentStatus: 2 })
    } else {
      this.setState({ paymentStatus: 1 })
    }
  } */
  //#endregion

  renderFormControl = ({ input, label, type, placeholder, meta: { touched, error }, className }) => {
    const { formatMessage } = this.props.intl;
    return (
      <div>
        <FormControl {...input} placeholder={placeholder} type={type} className={className} />
        {touched && error && <span className={s.errorMessage}>{formatMessage(error)}</span>}
      </div>
    )
  }

  async onExpressCheckoutReady({availablePaymentMethods}) {
    let expressCheckoutCount = 0;
    for( const method in availablePaymentMethods ) {
      if( availablePaymentMethods[method] ) ++expressCheckoutCount;
    }

    this.setState({expressCheckoutCount});
  }

  async onExpressCheckoutClick(event) {
    event.resolve({ business: { name: 'pleXpad' }, /* emailRequired: true, */ shippingAddressRequired: false });
  }

  async onExpressCheckoutConfirm(event) {
    const { stripe, elements, paymentIntentId, clientSecret, initialValues, bookDetails, dispatch, submit } = this.props;

    if (!stripe) {
      // Stripe.js hasn't loaded yet.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }

    // Confirm the PaymentIntent using the details collected by the Express Checkout Element
    const resp = await stripe.confirmPayment({
      // `elements` instance used to create the Express Checkout Element
      elements,
      // `clientSecret` from the created PaymentIntent
      clientSecret,
      confirmParams: {
        return_url: url + '/book/' + initialValues.listId + '?bookDetails=' + encodeURIComponent(JSON.stringify(Object.assign({}, {expressCheckoutReturn: true, paymentIntentId}, bookDetails)))
      },
      redirect: 'if_required'
    });

    if (resp.error) {
      // This point is only reached if there's an immediate error when
      // confirming the payment. Show the error to your customer (for example, payment details incomplete)
      toastr.error('Error', resp.error.message);
    } else if( resp && resp.paymentIntent && resp.paymentIntent.status == 'succeeded' ) {
      await dispatch({
        type: BOOKING_PAYMENT_SET_EXPRESS_CHECKOUT,
        payload: {
          isExpressCheckout: true
        }
      });

      //Attempt to complete checkout - show validation errors where applicable
      submit('PaymentForm');
    }
  }

  render() {
    const { originalIsAuthenticated } = this.props;
    const { guestAccountCreated } = this.props;
    const { isAuthenticated, openLoginModal, bookDetails } = this.props;
    const { /* hostDisplayName, houseRules, allowedPersonCapacity, */ paymentLoading/* , intl: { locale } */ } = this.props;
    const { handleSubmit, submitting, pristine, error, invalid/* , paymentType */ } = this.props;
    const { status, errorType, existingUserType } = this.props;
    const { initialValues } = this.props;
    const { isExpressCheckout } = this.props;
    const { monthlyPass, monthlyPassAuthDeposit, monthlyPassSubscriptionStage } = this.props;
    const { /* paymentStatus, */ load } = this.state;
    const { formatMessage } = this.props.intl;
    /* const {stripe, elements} = this.props; */

    let socialLoginRefer = '/book/' + initialValues.listId + '?bookDetails=' + encodeURIComponent(JSON.stringify(bookDetails));

    return (
      <div className={cx(s.spaceTop2, s.aboutNoMargin)}>
        <form onSubmit={handleSubmit}>
          <Row>
            {
            //#region Number of guests + Message to host
            /* <Col md={12} className={cx(s.textLeft, 'textAlignRightRtl')}>
              <div className={s.h3}>
                <FormattedMessage {...messages.aboutYourTrip} />
              </div>
              <div className={s.aboutPaymentDesc}>
                <FormattedMessage {...messages.aboutDescPayment} />
              </div>
              <div className={cx(s.bookItDetails, s.spaceTop2, s.space4)}>
                <span><FormattedMessage {...messages.whoComing} /></span>
                <Row className={s.spaceTop2}>
                  <Col md={12} lg={5}>
                    <Field name="guests" component={this.renderFormControlSelect} className={cx(s.formControlSelect, bt.commonControlSelect, 'paymentSelectAR')} >
                      {
                        this.renderGuests(allowedPersonCapacity)
                      }
                    </Field>
                  </Col>
                </Row>
              </div>
              <div className={s.displayTable}>
                <div className={s.displayTableRow}>
                  <div className={cx(s.displayTableCell, s.avatarSection, s.vtrTop)}>
                    <img src={'/images/avatar/medium_' + guestPicture} className={s.avatarImage} />
                  </div>
                  <div className={cx(s.displayTableCell, s.messageSection, s.vtrTop)}>
                    <div >
                      <span><FormattedMessage {...messages.sayHello} />:</span>
                    </div>
                    <div>
                      <Field
                        className={s.textArea}
                        name="message"
                        component={this.renderFormControlTextArea}
                        label={formatMessage(messages.descriptionInfo)}
                      />
                    </div>
                  </div>
                </div>
              </div>
              {
                houseRules.length > 0 && <div className={s.space4}>
                  <HouseRules
                    hostDisplayName={hostDisplayName}
                    houseRules={houseRules}
                  />
                </div>
              }
            </Col>
            */
            //#endregion
            }
            <Col md={12} sm={12} xs={12} lg={12} className={cx(s.textLeft, 'textAlignRightRtl', s.spaceTop2)}>
              {
              //#region Payment Methods
              /* <label className={bt.inputLabelText}>
                <FormattedMessage {...messages.choosePaymentLabel} />
              </label>
              <Field
                name="paymentType"
                type="text"
                className={cx(s.formControlSelect, s.fullWithSelect, bt.commonControlSelect, 'selectPaymentDropdown')}
                component={this.renderFormControlSelect}
                onChange={(e) => this.handlePayment(e)}
              >
                <option value={2}>{formatMessage(messages.creditCard)}</option>
              </Field> */
              //#endregion
              }
              {
                !originalIsAuthenticated && !isAuthenticated && <Row>
                  <Col lg={12} md={12} sm={12} xs={12} className={cx(s.noPadding)}>
                    <div className={'placeHolderFont'}>
                      <Col lg={12} md={12} sm={12} xs={12}>
                        <span className={s.login}><FormattedMessage {...messages.alreadyHaveAccount} /> <a href='#' onClick={() => openLoginModal(socialLoginRefer)}><FormattedMessage {...messages.login} /></a></span>
                      </Col>
                    </div>
                  </Col>
                  <Col lg={12} md={12} sm={12} xs={12} className={cx(s.noPadding, s.spaceTop2)}>
                    <div className={'placeHolderFont'}>
                      <Col lg={12} md={12} sm={12} xs={12}>
                        <div className={s.yourCardDetails}><FormattedMessage {...messages.yourDetails} /></div>
                      </Col>
                    </div>
                  </Col>
                  <Col lg={12} md={12} sm={12} xs={12}>
                    <label className={s.labelText}>
                      <FormattedMessage {...messages.name} />
                    </label>
                    <Field
                      name="name"
                      component={this.renderFormControl}
                      className={cx(s.cardInput, s.cardNumber, s.noBoxShadow, s.cardNumberSection, s.nameBackground)}
                      placeholder={formatMessage(messages.yourName)}
                    />
                  </Col>
                  <Col lg={12} md={12} sm={12} xs={12}>
                    <label className={s.labelText}>
                      <FormattedMessage {...messages.email} />
                    </label>
                    <Field
                      name="email"
                      type="email"
                      component={this.renderFormControl}
                      className={cx(s.cardInput, s.cardNumber, s.noBoxShadow, s.cardNumberSection, s.emailBackground)}
                      placeholder={formatMessage(messages.email)}
                    />
                  </Col>
                </Row>
              }
              {
                errorType && errorType == 'createUser' && (status == '401' || status == '403') && <Row>
                  <Col lg={12} md={12} sm={12} xs={12}>
                    <span className={cx(s.createUserError)}>
                      {
                        status == '401' && <React.Fragment>
                          {
                            ( existingUserType == 'email' ? <FormattedMessage {...messages.existingUserEmail} /> : ( existingUserType == 'google' ? <FormattedMessage {...messages.existingUserGoogle} /> : <FormattedMessage {...messages.existingUserFacebook} /> ) )
                          }
                          {' '}
                          <span className={s.login}><FormattedMessage {...messages.please} /> <a href='#' onClick={() => openLoginModal(socialLoginRefer)}><FormattedMessage {...messages.logIn} /></a>.</span>
                        </React.Fragment>
                      }
                      {
                        status == '403' && <FormattedMessage {...messages.existingUserAdmin} />
                      }
                    </span>
                  </Col>
                </Row>
              }
              {
                !originalIsAuthenticated && !guestAccountCreated && isAuthenticated && !monthlyPassSubscriptionStage && <Row>
                  <Col lg={12} md={12} sm={12} xs={12} className={cx(s.noPadding)}>
                    <div className={'placeHolderFont'}>
                      <Col lg={12} md={12} sm={12} xs={12}>
                        <div className={s.youAreLoggedIn}><FormattedMessage {...messages.youAreLoggedIn} /></div>
                      </Col>
                    </div>
                  </Col>
                </Row>
              }
              {
                (monthlyPass && monthlyPassSubscriptionStage) ? <Row>
                <Col lg={12} md={12} sm={12} xs={12} className={cx(s.noPadding)}>
                  <PaymentElement
                    className={cx(s.stripePaymentElementContainer)}
                    options={{
                      fields: {
                        billingDetails: {
                          email: 'never'
                        }
                      }
                    }}
                  />
                  {
                  //#region Manual Collection
                  /*
                  <Col lg={12} md={12} sm={12} xs={12}>
                    <div className={s.yourCardDetails}><FormattedMessage {...messages.yourBankAccountDetails} /></div>
                  </Col>
                  <Col lg={12} md={12} sm={12} xs={12}>
                    <label className={s.labelText}>
                      <FormattedMessage {...messages.bankAccountNumber} />
                    </label>
                    <Field
                      name="bankAccountNumber"
                      component={this.renderFormControl}
                      className={cx(s.cardInput, s.cardNumber, s.noBoxShadow, s.cardNumberSection, 'cardNumberRtlTwo')}
                      placeholder={'12345678'}
                    />
                  </Col>
                  <Col lg={12} md={12} sm={12} xs={12}>
                    <label className={s.labelText}>
                      <FormattedMessage {...messages.bankAccountSortCode} />
                    </label>
                    <Field
                      name="bankAccountSortCode"
                      component={this.renderFormControl}
                      className={cx(s.cardInput, s.cardNumber, s.noBoxShadow, s.cardNumberSection, s.bankAccountSortCode, 'cardNumberRtlTwo')}
                      placeholder={'00-00-00'}
                    />
                  </Col>
                  <Col lg={12} md={12} sm={12} xs={12}>
                    <label className={s.labelText}>
                      <FormattedMessage {...messages.bankAccountHolderName} />
                    </label>
                    <Field
                      name="bankAccountHolderName"
                      component={this.renderFormControl}
                      className={cx(s.cardInput, s.cardNumber, s.noBoxShadow, s.cardNumberSection, 'cardNumberRtlTwo')}
                      placeholder={'Company Ltd / Mr John Smith'}
                    />
                  </Col>
                  <Col lg={12} md={12} sm={12} xs={12} className={cx(s.pullRight, s.textRight)}>
                    <img src={imageTwo} className={cx(s.fullWidth, s.stripeImg)} />
                  </Col>
                  */
                  //#endregion
                  }
                </Col>
              </Row>
              :
              ( !isExpressCheckout ? ( !load ? <Loader /> : <React.Fragment>
                  { !monthlyPass && this.state.expressCheckoutCount !== 0 &&
                  <Row className={cx(s.space4, s.responsivecardSection)}>
                    <Col lg={12} md={12} sm={12} xs={12} className={cx(s.noPadding, s.spaceTop2)}>
                      <div className={cx(s.expressCheckoutContainer)}>
                      <div style={{display: 'block', visibility: this.state.expressCheckoutCount > 0 ? 'initial' : 'hidden'}}>
                        <ExpressCheckoutElement
                          options={{ paymentMethodOrder: ['googlePay'], buttonType: { googlePay: 'checkout' } }}
                          onReady={this.onExpressCheckoutReady}
                          onClick={this.onExpressCheckoutClick}
                          onConfirm={this.onExpressCheckoutConfirm}
                        />
                      </div>
                      {
                        this.state.expressCheckoutCount === -1 && <div className={cx(s.expressCheckoutLoader)}><Loader type={'circle'} show={true} /></div>
                      }
                      </div>
                    </Col>
                  </Row>
                  }
                  <Row className={cx(s.space4, s.spaceTop2, s.responsivecardSection, 'cardDetailsSection')}>
                    <Col lg={12} md={12} sm={12} xs={12} className={cx(s.noPadding)}>
                      <div className={'placeHolderFont'}>
                        <Col lg={12} md={12} sm={12} xs={12}>
                          <div className={s.yourCardDetails}><FormattedMessage {...messages.yourCardDetails} /></div>
                        </Col>
                        <Col lg={12} md={12} sm={12} xs={12}>
                          <label className={s.labelText}>
                            <FormattedMessage {...messages.paymentCardNumber} />
                          </label>
                          <CardNumberElement
                            options={{...stripeOptions, placeholder: '4242 4242 4242 4242'}}
                            className={cx(s.cardNumber, s.cardNumberSection, s.cardNumberSectionOne, 'cardNumberRtl')}
                          />
                        </Col>
                        <Col lg={4} md={4} sm={6} xs={6}>
                          <label className={s.labelText}>
                            <FormattedMessage {...messages.cardExpires} />
                          </label>
                          <CardExpiryElement
                            options={{...stripeOptions, placeholder: 'MM / YY'}}
                            className={cx(s.cardNumber, s.cardNumberSectionTwo, s.cardNumberSection, 'cardNumberRtl')}
                          />
                        </Col>
                        <Col lg={4} md={4} sm={6} xs={6}>
                          <label className={s.labelText}>
                            <FormattedMessage {...messages.cvv} />
                          </label>
                          <CardCvcElement
                            options={{...stripeOptions, placeholder: '_ _ _'}}
                            className={cx(s.cardNumber, s.cardNumberSectionThree, s.cardNumberSection, 'cardNumberRtlTwo')}
                          />
                        </Col>
                        <Col lg={4} md={4} sm={12} xs={12}>
                          <label className={s.labelText}>
                            <FormattedMessage {...messages.zipcode} />
                          </label>
                          <Field
                            name="zipcode"
                            component={this.renderFormControl}
                            className={cx(s.cardInput, s.cardNumber, s.noBoxShadow, s.cardNumberSection, s.cardNumberSectionFour, 'cardNumberRtlTwo')}
                            placeholder={formatMessage(messages.zipcode)}
                          />
                        </Col>
                        <Col lg={6} md={6} sm={5} xs={7}>
                          <img src={imageOne} className={cx(s.fullWidth, s.stripeImg)} />
                        </Col>
                        <Col lg={5} md={5} sm={4} xs={5} className={cx(s.pullRight, s.textRight)}>
                          <img src={imageTwo} className={cx(s.fullWidth, s.stripeImg)} />
                        </Col>
                      </div>
                    </Col>
                  </Row>
                </React.Fragment>
                )
                :
                <Row className={cx(s.space4, s.spaceTop2, s.responsivecardSection)}>
                  <Col lg={12} md={12} sm={12} xs={12} className={cx(s.noPadding, s.spaceTop2)}>
                    <div className={'placeHolderFont'}>
                      <Col lg={12} md={12} sm={12} xs={12}>
                        <div className={s.expressCheckoutComplete}><FormattedMessage {...messages.expressCheckoutComplete} /></div>
                      </Col>
                    </div>
                  </Col>
                </Row>)
              }
              {
                //#region PayPal
                /* paymentStatus == 1 &&
                <Row className={cx(s.space4, s.spaceTop3)}>
                  <Col xs={12} sm={12} md={12} lg={12}>
                    <div>
                      <label className={bt.inputLabelText}>
                        <FormattedMessage {...messages.paymentCurrency} />
                      </label>
                      {<Field name="paymentCurrency" disabled={paymentType == 2}
                        component={this.renderFormControlSelect}
                        className={cx(s.formControlSelect, bt.commonControlSelect, 'selectPaymentDropdown', s.fullWithSelect)} >
                        <option value="">{formatMessage(messages.chooseCurrency)}</option>
                        {
                          this.renderpaymentCurrencies()
                        }
                      </Field>}
                    </div>
                    <span className={cx(s.textLight, s.spaceTop1)}>
                      <FormattedMessage {...messages.loginInfo} />
                    </span>
                  </Col>
                </Row> */
                //#endregion
              }
              {
                //#region General Error Message
                /* createUserStatus == true && <Row className={s.space4}>
                  <Col xs={12} sm={12} md={12} lg={12}>
                    <div className={s.spaceTop3}>
                      <span>{error}</span>
                    </div>
                  </Col>
                </Row> */
                //#endregion
              }
              <Row className={s.space4}>
                <Col xs={12} sm={12} md={12} lg={12}>
                  <div className={s.spaceTop3}>
                    <Loader
                      type={"button"}
                      buttonType={"submit"}
                      className={cx(bt.btnPrimary, 'arButtonLoader', s.fullWidth, s.btnPadding)}
                      disabled={pristine && !monthlyPass || submitting || error || invalid}
                      show={paymentLoading}
                      label={formatMessage(monthlyPassAuthDeposit ? messages.authorise : ( monthlyPass ? messages.subscribe : ( initialValues.total > 0 && !isExpressCheckout ? messages.payNow : messages.bookNow )))}
                    />
                  </div>
                </Col>
              </Row>
              {
                //#region Free Trial Booking (No Card Auth)
                /* initialValues.total == 0 && <Row className={s.space4}>
                <Col xs={12} sm={12} md={12} lg={12}>
                  <div className={s.spaceTop3}>
                    <Loader
                      type={"button"}
                      buttonType={"submit"}
                      className={cx(bt.btnPrimary, 'arButtonLoader', s.fullWidth, s.btnPadding)}
                      disabled={submitting || error}
                      show={paymentLoading}
                      label={formatMessage(messages.bookNow)}
                    />
                  </div>
                </Col>
              </Row> */
              //#endregion
              }
            </Col>
          </Row>
        </form>
      </div>
    );
  }
}

PaymentForm = reduxForm({
  form: 'PaymentForm', // a unique name for this form
  validate,
  onSubmit: submitPaymentForm
})(PaymentForm);

// Decorate with connect to read form values
//const selector = formValueSelector('PaymentForm'); // <-- same as form name

const mapState = (state) => ({
  isAuthenticated: state.runtime.isAuthenticated,
  guestAccountCreated: state.book.guestAccountCreated,
  bookDetails: state.book.bookDetails,
  status: state.book.status,
  errorType: state.book.errorType,
  existingUserType: state.book.existingUserType,
  paymentLoading: state.book.paymentLoading,
  paymentIntentId: state.book.paymentIntentId,
  clientSecret: state.book.clientSecret,
  setupIntentId: state.book.setupIntentId,
  setupIntentClientSecret: state.book.bookDetails.setupIntentClientSecret,
  isExpressCheckout: state.book.isExpressCheckout,
  //paymentCurrencyList: state.currency.availableCurrencies,
  //paymentType: selector(state, 'paymentType')
});

const mapDispatch = {
  openLoginModal
};

export default injectIntl(withStyles(s, bt)(connect(mapState, mapDispatch)(PaymentForm)));


// WEBPACK FOOTER //
// src/components/Booking/Payment/PaymentForm.js